/** @jsxImportSource @emotion/react */
import React from 'react'
import colors from '@sportninja/common/constants/appColors'

interface NextBroadcastIconProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: number
  color?: string
}

const NextBroadcastIcon: React.FC<NextBroadcastIconProps> = ({
  size = 16,
  color = colors.WHITE,
  className,
  style,
  ...rest
}) => {
  return (
    <span className={`anticon ${className || ''}`} style={style} {...rest}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 16 16'
        fill='none'
      >
        <path
          d='M5.17337 10.8266C4.44671 10.1066 4.00004 9.10662 4.00004 7.99995C4.00004 6.89329 4.44671 5.89329 5.17337 5.17329L6.12004 6.11995C5.63337 6.59995 5.33337 7.26662 5.33337 7.99995C5.33337 8.73329 5.63337 9.39995 6.11337 9.88662L5.17337 10.8266ZM10.8267 10.8266C11.5534 10.1066 12 9.10662 12 7.99995C12 6.89329 11.5534 5.89329 10.8267 5.17329L9.88004 6.11995C10.3667 6.59995 10.6667 7.26662 10.6667 7.99995C10.6667 8.73329 10.3667 9.39995 9.88671 9.88662L10.8267 10.8266ZM8.00004 6.66662C7.26671 6.66662 6.66671 7.26662 6.66671 7.99995C6.66671 8.73329 7.26671 9.33329 8.00004 9.33329C8.73337 9.33329 9.33337 8.73329 9.33337 7.99995C9.33337 7.26662 8.73337 6.66662 8.00004 6.66662ZM13.3334 7.99995C13.3334 9.47329 12.7334 10.8066 11.7667 11.7666L12.7134 12.7133C13.92 11.5066 14.6667 9.83995 14.6667 7.99995C14.6667 6.15995 13.92 4.49329 12.7134 3.28662L11.7667 4.23329C12.7334 5.19329 13.3334 6.52662 13.3334 7.99995ZM4.23337 4.23329L3.28671 3.28662C2.08004 4.49329 1.33337 6.15995 1.33337 7.99995C1.33337 9.83995 2.08004 11.5066 3.28671 12.7133L4.23337 11.7666C3.26671 10.8066 2.66671 9.47329 2.66671 7.99995C2.66671 6.52662 3.26671 5.19329 4.23337 4.23329Z'
          fill={color}
        />
      </svg>
    </span>
  )
}

export default NextBroadcastIcon
